import { render, staticRenderFns } from "./itemTemplate.vue?vue&type=template&id=0cd31e80&"
import script from "./itemTemplate.vue?vue&type=script&lang=js&"
export * from "./itemTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports